
import { Component } from '@angular/core';

@Component({
  selector: 'siat-card-group',
  templateUrl: './card-group.component.html',
   
  imports: [],
})
export class CardGroupComponent {}
